import React, { Fragment } from "react";

import { Table, Typography, colors, makeStyles } from "@material-ui/core";
import { get, startCase } from "lodash";

import { formatDateShort } from "@ds-developer/frontend";

import { DataTableProps } from "../types";

const useStyles = makeStyles(theme => ({
  title: {
    padding: theme.spacing(3, 2, 2, 2),

    [theme.breakpoints.up("sm")]: {
      padding: theme.spacing(0),
      marginBottom: theme.spacing(2),
    },
  },
  tableRow: {
    borderBottom: `1px solid ${colors.blueGrey[50]}`,
  },
  tableCell: {
    padding: theme.spacing(3, 2, 3, 2),
    minWidth: theme.spacing(13),

    [theme.breakpoints.up("sm")]: {
      minWidth: theme.spacing(10),
      paddingLeft: theme.spacing(0),
      paddingRight: theme.spacing(0),
    },
  },
}));

const DataTable = ({ data = {}, title }: DataTableProps) => {
  const classes = useStyles();

  return (
    <Fragment>
      <Typography variant="h2" color="textSecondary" className={classes.title}>
        {title}
      </Typography>
      <Table>
        <tbody>
          {Object.entries(data)
            .filter(([, value]) => Boolean(value))
            .map(([key, value]) => (
              <tr key={key} className={classes.tableRow}>
                <td className={classes.tableCell}>{startCase(key)}</td>
                {get(data, key) instanceof Date && (
                  <td
                    className={classes.tableCell}
                    data-test={`data-table-value-${key}`}
                  >
                    {formatDateShort(get(data, key))}
                  </td>
                )}
                {!(get(data, key) instanceof Date) && (
                  <td
                    className={classes.tableCell}
                    data-test={`data-table-value-${key}`}
                  >
                    {value}
                  </td>
                )}
              </tr>
            ))}
        </tbody>
      </Table>
    </Fragment>
  );
};

export default DataTable;
